import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState } from "redmond";

import { ExperiencesShop } from "./component";
import { IStoreState } from "../../reducers/types";
import { getEntryType, getFromDate, getUntilDate } from "../search/reducer";
import {
  fetchExperiencesShop,
  fetchExperiencesShopOptions,
  fetchExperiencesShopReviews,
  setTravelerCounts,
  setSelectedExperience,
  setSelectedTime,
  setSelectedDate,
  setSelectedBookableItem,
} from "./actions/actions";
import {
  getExperiencesShopOverview,
  getExperiencesShopWhatsIncluded,
  getExperiencesShopCallState,
  getExperiencesShopDetails,
  getExperiencesShopContactInfo,
  getExperiencesShopWhatToExpect,
  getExperienceName,
  getExperienceProviderName,
  getExperienceId,
  getExperiencesShopGallery,
  getSelectedExperienceId,
  getExperiencesShopSimilar,
  getExperiencesShopCancellationPolicy,
  getExperiencesSearchLocation,
  getExperiencesShopAgeBands,
  getExperiencesShopCustomerReviews,
  getExperiencesCheckoutBreakdown,
  getSelectedTime,
  getSelectedDate,
  getSelectedBookableItem,
  getExperiencesNoAvailability,
  getExperiencesShopOptionsCallState,
  getTravelerCountsWithMinimums,
  getActivityDetailsProperties,
} from "./reducer";
import { setFromDate, setUntilDate } from "../search/actions/actions";
import {
  getRewardsAccountWithLargestValue,
  getSelectedAccount,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../rewards/reducer";
import { fetchTravelWalletDetails } from "../travel-wallet/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  locationLabel: getExperiencesSearchLocation(state),
  experienceId: getExperienceId(state),
  experienceName: getExperienceName(state),
  experienceProviderName: getExperienceProviderName(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  isLoading: getExperiencesShopCallState(state) === CallState.InProcess,
  shopDetails: getExperiencesShopDetails(state),
  shopOverview: getExperiencesShopOverview(state),
  shopWhatsIncluded: getExperiencesShopWhatsIncluded(state),
  shopContactInfo: getExperiencesShopContactInfo(state),
  shopWhatToExpect: getExperiencesShopWhatToExpect(state),
  shopCustomerReviews: getExperiencesShopCustomerReviews(state),
  shopGallery: getExperiencesShopGallery(state),
  selectedExperienceId: getSelectedExperienceId(state),
  shopSimilar: getExperiencesShopSimilar(state),
  largestValueAccount: getRewardsAccountWithLargestValue(state),
  shopCancellationPolicy: getExperiencesShopCancellationPolicy(state),
  parsedAgeBands: getExperiencesShopAgeBands(state),
  travelerCounts: getTravelerCountsWithMinimums(state),
  shopPricingBreakdown: getExperiencesCheckoutBreakdown(state),
  rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  shopCallState: getExperiencesShopCallState(state),
  shopOptionsCallState: getExperiencesShopOptionsCallState(state),
  activityDetailsProperties: getActivityDetailsProperties(state),
  selectedTime: getSelectedTime(state),
  selectedDate: getSelectedDate(state),
  selectedBookableItem: getSelectedBookableItem(state),
  noAvailability: getExperiencesNoAvailability(state),
  selectedRewardsAccount: getSelectedAccount(state),
  entryType: getEntryType(state),
});

const mapDispatchToProps = {
  setSelectedExperience,
  fetchExperiencesShop,
  setFromDate,
  setUntilDate,
  fetchExperiencesShopReviews,
  fetchExperiencesShopOptions,
  setTravelerCounts,
  fetchTravelWalletDetails,
  setSelectedTime,
  setSelectedDate,
  setSelectedBookableItem,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedExperiencesShop = withRouter(connector(ExperiencesShop));
